var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"fill-height pa-0",attrs:{"fluid":""}},[_c('div',{staticClass:"scanner-container"},[_c('div',{staticClass:"scanner-zone"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }